import React from 'react';
import {
 ChevronsUpDown, ArrowLeft, Database
} from 'lucide-react';
import {
 useNavigate
} from 'react-router-dom';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from 'shared/components/ui/dropdown-menu';
import {
    SidebarMenu,
    SidebarMenuItem,
    SidebarMenuButton,
    useSidebar,
} from 'shared/components/ui/sidebar';
import {
 useDataBuilderV2
} from '../DataBuilderV2Context';

const AppSwitcher: React.FC = () => {
    const {
 appFullName, apps, appId
} = useDataBuilderV2();
    const {
 isMobile
} = useSidebar();
    const navigate = useNavigate();

    const handleSwitchApp = (targetAppId: string) => {
        if (targetAppId === appId) return;
        navigate(`../../${targetAppId}/data-builder-v2`, {
 relative: 'path'
});
    };

    const handleBackToHub = () => {
        navigate('../..', {
 relative: 'path'
});
    };

    return (
        <SidebarMenu>
            <SidebarMenuItem>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <SidebarMenuButton
                            size="lg"
                            className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
                        >
                            {/* <div className="flex aspect-square size-8 items-center justify-center rounded-lg overflow-hidden">
                                <img src={bexLogo} alt="BeX" className="size-8 object-contain" />
                            </div> */}
                            <div className="grid flex-1 text-left text-sm leading-tight">
                                <span className="truncate font-semibold">{appFullName || 'Loading...'}</span>
                                <span className="truncate text-xs text-muted-foreground">Data Builder</span>
                            </div>
                            <ChevronsUpDown className="ml-auto" />
                        </SidebarMenuButton>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
                        align="start"
                        side={isMobile ? 'bottom' : 'right'}
                        sideOffset={4}
                    >
                        <DropdownMenuLabel className="text-xs text-muted-foreground">Applications</DropdownMenuLabel>
                        {apps.map((app) => (
                            <DropdownMenuItem
                                key={app.app_id}
                                onClick={() => handleSwitchApp(app.app_id)}
                                className={app.app_id === appId ? 'bg-accent' : ''}
                            >
                                <Database className="mr-2 size-4" />
                                <span className="truncate">{app.full_name}</span>
                            </DropdownMenuItem>
                        ))}
                        <DropdownMenuSeparator />
                        <DropdownMenuItem onClick={handleBackToHub}>
                            <ArrowLeft className="mr-2 size-4" />
                            Back to App Hub
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </SidebarMenuItem>
        </SidebarMenu>
    );
};

export default AppSwitcher;
